"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgMicrophoneFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M19 10a1 1 0 011 1c0 4.071-3.061 7.435-7 7.93V20h2a1 1 0 010 2H9a1 1 0 010-2h2v-1.07c-3.939-.495-7-3.859-7-7.93a1 1 0 112 0c0 3.308 2.691 6 6 6s6-2.692 6-6a1 1 0 011-1z' }),
    react_1.default.createElement("path", { d: 'M8 6a4 4 0 118 0v5a4 4 0 01-8 0V6z' }))); };
exports.default = SvgMicrophoneFilled;
//# sourceMappingURL=MicrophoneFilled.js.map